const mapping: Record<
  string,
  (lambdaParameter: string, value: any, otherValues: any) => string | null
> = {
  userName: (lambdaParameter, value) =>
    `${lambdaParameter}.UserName.Contains("${value}")`,
  companyId: (lambdaParameter, value) =>
    `${lambdaParameter}.Company.Id.Equals(${value})`,
  roleId: (lambdaParameter, value) =>
    `${lambdaParameter}.Roles.Any(r=>r.Id.Equals(${value}))`,
  search: (lambdaParameter, value) =>
    `${value
      .toString()
      .split(' ')
      .map(
        (q: string) =>
          `(${lambdaParameter}.Id+" "+${lambdaParameter}.UserName).Contains("${q}")`,
      )
      .join('&&')}`,
  filterNotificationTagId: () => null,
  notificationTagId: (lambdaParameter, value, otherValues) =>
    otherValues.filterNotificationTagId === false
      ? null
      : `${lambdaParameter}.Tags.Any(vd=>vd.Id==${value})`,
}

const filterMapper = (key: string) =>
  mapping[key] as (
    lambdaParameter: string,
    value: any,
    otherValues: any,
  ) => string

export default filterMapper
